import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Wand2, Globe } from "lucide-react";

export const CatalogHealthCard = () => {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const feedUrl = `${process.env.REACT_APP_BACKEND_URL}/api/feeds/google-shopping.xml`;
  const sitemapUrl = `${process.env.REACT_APP_BACKEND_URL}/api/seo/sitemap.xml`;

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/recategorize");
      setResult(data);
      toast.success(data.updated ? `${data.updated} products re-categorized` : "Catalogue already clean — nothing to fix");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="catalog-health-card">
      <div className="flex items-center gap-2">
        <Globe className="h-4 w-4 text-[#34C759]" />
        <h2 className="font-bold text-lg">Catalogue reach &amp; health</h2>
      </div>
      <div className="mt-3 text-sm text-neutral-400 space-y-1">
        <div>Google Shopping feed: <a href={feedUrl} target="_blank" rel="noreferrer" className="text-[#007AFF] hover:underline break-all" data-testid="feed-url-link">{feedUrl}</a></div>
        <div>SEO sitemap: <a href={sitemapUrl} target="_blank" rel="noreferrer" className="text-[#007AFF] hover:underline break-all" data-testid="sitemap-url-link">{sitemapUrl}</a></div>
        <div className="text-xs text-neutral-500 mt-2">Submit the feed in Google Merchant Center and the sitemap in Google Search Console — every live product then appears in Google's free shopping listings.</div>
      </div>
      <Button
        onClick={run}
        disabled={busy}
        data-testid="recategorize-btn"
        className="mt-4 rounded-full bg-white text-black hover:bg-neutral-200 h-10 px-6 font-semibold"
      >
        <Wand2 className="h-4 w-4 mr-2" />
        {busy ? "AI is sorting…" : "AI re-categorize catalogue"}
      </Button>
      {result && (
        <div className="mt-3 text-xs text-neutral-400" data-testid="recategorize-result">
          Scanned {result.scanned ?? 0} · updated {result.updated}.
          {result.changes?.slice(0, 8).map((c, i) => (
            <div key={i} className="text-neutral-500">• {c.title} → <span className="text-[#34C759]">{c.category}</span></div>
          ))}
        </div>
      )}
    </div>
  );
};
